import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useEditMode } from '../contexts/EditModeContext';
import { useToast } from '../hooks/use-toast';
import axios from 'axios';
import { Lock } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { enableAdminMode } = useEditMode();
  const { toast } = useToast();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    
    if (!password) {
      toast({
        title: "Errore",
        description: "Inserisci la password",
        variant: "destructive"
      });
      return;
    }

    setLoading(true);
    
    try {
      const response = await axios.post(`${API}/auth/login`, { password });
      
      if (response.data.success) {
        enableAdminMode();
        toast({
          title: "Accesso riuscito!",
          description: "Benvenuto nell'area admin",
        });
        navigate('/');
      }
    } catch (error) {
      toast({
        title: "Errore",
        description: error.response?.data?.detail || "Password errata",
        variant: "destructive"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '48px',
        maxWidth: '400px',
        width: '100%',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{
          textAlign: 'center',
          marginBottom: '32px'
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px'
          }}>
            <Lock style={{ width: '40px', height: '40px', color: 'white' }} />
          </div>
          <h1 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: '#1f2937',
            marginBottom: '8px'
          }}>
            Area Admin
          </h1>
          <p style={{
            fontSize: '14px',
            color: '#6b7280'
          }}>
            Tabaccheria N.16
          </p>
        </div>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: '24px' }}>
            <label style={{
              display: 'block',
              fontSize: '14px',
              fontWeight: '500',
              color: '#374151',
              marginBottom: '8px'
            }}>
              Password Admin
            </label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Inserisci la password"
              disabled={loading}
              autoFocus
              style={{
                fontSize: '16px',
                padding: '12px 16px'
              }}
            />
          </div>

          <Button 
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
              padding: '12px',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            {loading ? "Verifica..." : "Accedi"}
          </Button>
        </form>

        <div style={{
          marginTop: '24px',
          textAlign: 'center'
        }}>
          <a 
            href="/"
            style={{
              fontSize: '14px',
              color: '#6b7280',
              textDecoration: 'none'
            }}
          >
            ← Torna al sito
          </a>
        </div>
      </div>
    </div>
  );
};
